import Vue from 'vue'
import Amplify, * as AmplifyModules from 'aws-amplify'
import { AmplifyPlugin } from 'aws-amplify-vue'
import CONFIG from './config'

Amplify.configure(CONFIG)

Vue.use(AmplifyPlugin, AmplifyModules)
